import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../global';
import { Observable } from 'rxjs/Observable';
import { Ticket } from '../../models/ticket/ticket';

@Injectable()
export class TicketService {

  constructor(
    private http: HttpClient
  ) { }

  sendTicket(ticket: Ticket): Observable<any> {
    const json = JSON.stringify(ticket);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post(GLOBAL.url + '/ticket/ticket.php/send-ticket', params, {headers: headers});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ticket/ticket.service.ts